<div class="mb-3">
  @if (!expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(true)">
      <mat-icon class="icon">chevron_right</mat-icon>
      <strong>Expand for Encounter Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(false)">
      <mat-icon class="icon">expand_more</mat-icon>
      <strong>Encounter Eligibility Details</strong>
    </div>
    <div class="content">
      <p>
        Encounter type data shared from your EHR is used to determine patient care ownership and eligibility for your 340B claim verifications. To ensure that claims are verified correctly, each encounter type must be reviewed and flagged appropriately.
      </p>

      <p>Status Definitions:</p>

      <ul>
        <li class="mb-2"><strong class="eligibility-status eligible">ELIGIBLE</strong> – encounters of this type will be used to satisfy patient care ownership requirements and WILL count towards claim verifications.</li>
        <li class="mb-2"><strong class="eligibility-status ineligible">INELIGIBLE</strong> – encounters of this type will not be used to satisfy patient care ownership and WILL NOT count towards claim verifications.</li>
        <li><strong class="eligibility-status new">NEW</strong> – this encounter type has not been reviewed. Encounters of this type will not be used to satisfy patient care ownership until the status is updated. Please review and update NEW encounter types promptly to avoid gaps in claim eligibility.</li>
      </ul>
    </div>
  }
</div>

